export default "__VITE_ASSET__CVASzKbw__"